module.exports = __webpack_public_path__ + "img/connect-by-happiness_1.ab403a75.png";